module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAJCAYAAAALpr0TAAAA30lEQVQYlW3PwSpFURTG8d9FCqNznsJom3gFxjLiHFdEBobKzMTEKyAl0mbmFYwMDfZJMvIIp5QS3Trat5OBrNla6/u+/1qDoko3eGhjuPRPlXWzh5UJnOKgrJvqr6ysm23s40jXdYoqLRZVei2qNMx9P9stqvRcVGkh9xm9jEfM4wrHmMYhtvCG1Yxex3kbwxM2cTJGUbcxJFxgKSfO9EldG8NaWTcLGOEF9/jAziDzy7rJqFt8YQOTuOsNwzaG0VjYfziLM0z1N77nj9sYstmvsBfP4RrfGdfG8Dle4Ad7SlfSVKvzTAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/electricity/bottom_arrow.png
// module id = bh4K
// module chunks = 1